import { getI18n } from 'react-i18next';

export const VALIDATION_AUCTION_LIMIT_EMPTY_PRODUCT_ID = 'validation.auctionLimit.emptyProductId';
export const VALIDATION_AUCTION_LIMIT_PRODUCT_NOT_ACTIVE = 'validation.auctionLimit.productNotActive';
export const VALIDATION_AUCTION_LIMIT_PRODUCT_NOT_EXIST = 'validation.auctionLimit.productNotExist';
export const VALIDATION_AUCTION_LIMIT_PRODUCT_NOT_SECURITY = 'validation.auctionLimit.productNotSecurity';
export const VALIDATION_AUCTION_LIMIT_EMPTY_MEMBER_ID = 'validation.auctionLimit.emptyMemberId';
export const VALIDATION_AUCTION_LIMIT_INVALID_MEMBER = 'validation.auctionLimit.invalidMember';
export const VALIDATION_AUCTION_LIMIT_EMPTY_LIMIT_VALUE = 'validation.auctionLimit.emptyLimitValue';
export const VALIDATION_AUCTION_LIMIT_INVALID_LIMIT_VALUE = 'validation.auctionLimit.invalidLimitValue';
export const VALIDATION_AUCTION_LIMIT_ALREADY_EXISTS = 'validation.auctionLimit.alreadyExists';
export const ERROR_AUCTION_LIMIT_NOT_FOUND = 'auctionLimit.notFound';

export const createAuctionLimitErrorMessage = (code, params) => { // NOSONAR javascript:S3800
    let result;
    const i18n = getI18n();
    switch (code) {
        case VALIDATION_AUCTION_LIMIT_EMPTY_PRODUCT_ID:
            result = i18n.t('auction-limits.error.auction-limit-product-id-empty');
            break;
        case VALIDATION_AUCTION_LIMIT_PRODUCT_NOT_ACTIVE:
            result = i18n.t('auction-limits.error.auction-limit-product-not-active');
            break;
        case VALIDATION_AUCTION_LIMIT_PRODUCT_NOT_EXIST:
            result = i18n.t('auction-limits.error.auction-limit-product-not-exist');
            break;
        case VALIDATION_AUCTION_LIMIT_PRODUCT_NOT_SECURITY:
            result = i18n.t('auction-limits.error.auction-limit-product-not-security');
            break;
        case VALIDATION_AUCTION_LIMIT_EMPTY_MEMBER_ID:
            result = i18n.t('auction-limits.error.auction-limit-member-id-empty');
            break;
        case VALIDATION_AUCTION_LIMIT_INVALID_MEMBER:
            result = i18n.t('auction-limits.error.auction-limit-member-invalid');
            break;
        case VALIDATION_AUCTION_LIMIT_EMPTY_LIMIT_VALUE:
            result = i18n.t('auction-limits.error.auction-limit-empty-limit-value');
            break;
        case VALIDATION_AUCTION_LIMIT_INVALID_LIMIT_VALUE:
            result = i18n.t('auction-limits.error.auction-limit-invalid-limit-value');
            break;
        case VALIDATION_AUCTION_LIMIT_ALREADY_EXISTS:
            result = i18n.t('auction-limits.error.auction-limit-already-exists');
            break;
        case ERROR_AUCTION_LIMIT_NOT_FOUND:
            result = i18n.t('auction-limits.error.auction-limit-not-found');
            break;
        default:
            result = undefined;
    }
    return result;
};
